import React, { useMemo } from 'react'
import { Row, Col } from 'react-bootstrap'
import {
  CONTACT_DETAIL_FIELDS_SUPPORTED_INTEGRATIONS,
  getIntegrationDisplayName,
  IntegrationServiceId,
  ZOCKS_CONTACT_FIELDS,
} from '../../../../../../../common/integrations'
import { MapContactFieldsSection } from './MapContactFieldsSection'
import { MapContactDetailFieldsSection } from './MapContactDetailFieldsSection'
import { AdditionalFieldSelector } from '../AdditionalFieldSelector'
import { useFormContext } from 'react-hook-form'
import { IntegrationSettings } from '../../../schema'
import { IntegrationMappingFilterSection } from '../IntegrationMappingFilterSection'
import { SetOwnershipSection } from './SetOwnershipSection'

interface CustomContactAdminSettingsProps {
  serviceId: IntegrationServiceId
  formKey?: number
}

export const CustomContactAdminSettings: React.FC<CustomContactAdminSettingsProps> = ({ serviceId, formKey = 0 }) => {
  const { watch } = useFormContext<IntegrationSettings>()
  const contactFields = watch('mappings.contact.fields')
  const alreadyAddedFieldKeys = useMemo(() => Object.keys(contactFields || {}), [contactFields])

  const coreFieldKeys = useMemo(() => ZOCKS_CONTACT_FIELDS.map((m) => m.zocksKey), [])

  return (
    <>
      <Row className='mt-7'>
        <Col>
          <MapContactFieldsSection serviceId={serviceId} key={formKey} />
        </Col>
      </Row>
      {CONTACT_DETAIL_FIELDS_SUPPORTED_INTEGRATIONS.includes(serviceId) ? (
        <Row className='mt-7'>
          <Col>
            <MapContactDetailFieldsSection serviceId={serviceId} key={formKey} />
          </Col>
        </Row>
      ) : null}
      <Row className='mt-7'>
        <Col>
          <SetOwnershipSection serviceId={serviceId} />
        </Col>
      </Row>
      <Row className='mt-7'>
        <Col>
          <IntegrationMappingFilterSection
            key={formKey}
            serviceId={serviceId}
            mappingKey='contact'
            title='Contact Filters'
            description={`Add filters to control which ${getIntegrationDisplayName(serviceId)} contacts Zocks queries. Conditions within a filter group are combined with AND; filter groups are combined with OR, so a contact is returned if it matches any group.`}
          />
        </Col>
      </Row>
      <Row className='mt-7'>
        <Col>
          <AdditionalFieldSelector
            title={`Field-Level Contact Updates`}
            description={`Select which ${getIntegrationDisplayName(serviceId)} fields to populate when Zocks creates or updates a contact.`}
            serviceId={serviceId}
            mappingObjectName='contact'
            ignoreKeys={coreFieldKeys}
            alreadyAddedFields={alreadyAddedFieldKeys}
          />
        </Col>
      </Row>
    </>
  )
}
